/**
 * FadeImageGrid — custom element for the "Fade Image Grid" section.
 *
 * Responsibilities:
 *  Fade-in — IntersectionObserver toggles .is-visible on each .fig__fade
 *  element (title + grid items). Repeats every time the element re-enters
 *  the viewport. Grid items are staggered by 60 ms each.
 */

if (!customElements.get('fade-image-grid')) {
  class FadeImageGrid extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this._initFade());
    }

    _initFade() {
      if (this.dataset.fade !== 'true') return;

      // Title first, then each grid item
      const title = this.querySelector('.fig__title');
      const items = [...this.querySelectorAll('.fig__item')];
      const els   = [...(title ? [title] : []), ...items];

      if (!els.length) return;

      // Stagger: title gets 0ms, items stagger by 60ms each
      let delay = 0;
      if (title) { title.style.transitionDelay = '0ms'; delay = 60; }
      items.forEach((el, i) => {
        el.style.transitionDelay = (delay + i * 60) + 'ms';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
      );

      els.forEach((el) => {
        el.classList.add('fig__fade');
        observer.observe(el);
      });
    }
  }

  customElements.define('fade-image-grid', FadeImageGrid);
}
